import { render } from "./PrivateBookingEditDialog.vue?vue&type=template&id=6b8637ba"
import script from "./PrivateBookingEditDialog.vue?vue&type=script&lang=js"
export * from "./PrivateBookingEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__